import { gql } from '@apollo/client';

export const Interest = gql`
  fragment Interest on Interest {
    id
    label
  }
`;
